import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  autocompleteOptionSelectedStylesSAG,
  autocompleteOptionSelectedStylesSHS,
  autocompleteOptionStylesSAG,
  autocompleteOptionStylesSHS,
  autocompleteionOptionTextStylesSAG,
  autocompleteionOptionTextStylesSHS,
} from './autocomplete-options.styles';

@Component({
  selector: 'sag-ui-autocomplete-option',
  templateUrl: './autocomplete-option.component.html',
  styleUrls: [],
})
export class AutocompleteOptionComponent {
  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;

  @Input()
  selected = false;

  @Input()
  hidden = false;

  @Output()
  // eslint-disable-next-line
  autocomplete: EventEmitter<[string, any]> = new EventEmitter();

  @ViewChild('text') text!: ElementRef;

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  protected get containerClasses(): string {
    const containerStyles = componentStylesByTheme(
      this.theme,
      autocompleteOptionStylesSAG,
      autocompleteOptionStylesSHS
    );

    const autocompleteedContainerStyles = componentStylesByTheme(
      this.theme,
      autocompleteOptionSelectedStylesSAG,
      autocompleteOptionSelectedStylesSHS
    );

    return this.selected
      ? autocompleteedContainerStyles()
      : containerStyles();
  }

  protected get textClasses(): string {
    const textStyles = componentStylesByTheme(
      this.theme,
      autocompleteionOptionTextStylesSAG,
      autocompleteionOptionTextStylesSHS
    );

    return textStyles();
  }

  protected onClick() {
    const innerText = this.text.nativeElement.innerText;
    this.autocomplete.emit([innerText, this.value]);
  }

  protected onKeyDown(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      event.preventDefault();
      this.onClick();
      (event.target as HTMLDivElement).focus();
    }
  }
}
